import React from 'react';

interface OrganizationHeaderProps {
  onBack: () => void;
}

const OrganizationHeader: React.FC<OrganizationHeaderProps> = ({ onBack }) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <button
          onClick={onBack}
          className="text-blue-600 hover:text-blue-800 flex items-center space-x-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span>Back to Users of ARiA</span>
        </button>
      </div>
    </div>
  );
};

export default OrganizationHeader;
